
import React, { useState, useEffect } from 'react';
import { getTranslation } from '../utils/translations';
import { detectBrowserLanguage } from '../utils/appLanguage';

const CookieConsent: React.FC = () => {
    const [show, setShow] = useState(false);
    const browserLang = detectBrowserLanguage();
    const t = (key: any) => getTranslation(browserLang, key);

    useEffect(() => {
        const consent = localStorage.getItem('mealPai_cookie_consent');
        if (!consent) {
            setShow(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('mealPai_cookie_consent', 'true');
        setShow(false);
    };

    if (!show) return null;

    return (
        <div className="absolute bottom-0 left-0 right-0 bg-slate-900/95 backdrop-blur shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-[100] border-t border-slate-700 p-4 animate-fade-in">
            <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
                <div className="text-slate-300 text-xs sm:text-sm text-center sm:text-start leading-relaxed">
                    <p>
                        {t('gdprNotice')}
                    </p>
                </div>
                <button 
                    onClick={handleAccept}
                    className="px-6 py-2 bg-sky-600 text-white font-bold rounded hover:bg-sky-700 transition-colors text-xs sm:text-sm whitespace-nowrap shadow-lg"
                >
                    {t('iUnderstand')}
                </button>
            </div>
        </div>
    );
};

export default CookieConsent;
